import { postMethod, putMethod } from '../../common/api';

export const createSubTransaction = (id) =>
  postMethod(`/api/block-booking/sub-transactions/${id}`, {});

export const resumeCreatingSubTransactions = (id) =>
  postMethod(`/api/block-booking/sub-transactions/${id}/resume`, {});

export const transitSubTransactions = (id) =>
  putMethod(`/api/block-booking/sub-transactions/${id}`, {});

export const resumeTransitSubTransactions = (id) =>
  putMethod(`/api/block-booking/sub-transactions/${id}/resume`, {});

export const speculateTransaction = (body) => {
  return postMethod('/api/block-booking/speculate', body);
};

export const confirmPaymentApi = (body) => {
  return putMethod(`/api/block-booking/confirm-payment`, body);
};
